// Bulgarian translations for autotrader.ca equipment terms.
// Unmapped terms fall back to the original English text.
const EQUIPMENT_BG: Record<string, string> = {
  '360° camera': '360° камера',
  'AM/FM Stereo': 'AM/FM радио',
  'Adaptive Cruise Control': 'Адаптивен круиз контрол',
  'Air conditioning': 'Климатик',
  'Air suspension': 'Въздушно окачване',
  'Alarm': 'Аларма',
  'Alloy wheels': 'Алуминиеви джанти',
  'Alloy wheels (19")': 'Алуминиеви джанти (19")',
  'Alloy wheels (21")': 'Алуминиеви джанти (21")',
  'Ambient lighting': 'Амбиентно осветление',
  'Anti-lock braking system (ABS)': 'Антиблокираща система (ABS)',
  'Armrest': 'Подлакътник',
  'Auto Dimming Rearview Mirror': 'Автоматично затъмняващо се огледало',
  'Auto-leveling Headlights': 'Самонивелиращи се фарове',
  'Automatic Climate Control, Dual-Zone': 'Двузонов автоматичен климатроник',
  'Automatic climate control': 'Автоматичен климатроник',
  'Back-Up Camera': 'Камера за задно виждане',
  'Bi-Xenon headlights': 'Би-ксенонови фарове',
  'Blind spot monitor': 'Следене на мъртвата зона',
  'Bluetooth Connection': 'Bluetooth връзка',
  'CD player': 'CD плейър',
  'Cooled Seats': 'Вентилирани седалки',
  'Cruise control': 'Круиз контрол',
  'Daytime running lights': 'Дневни светлини',
  'Digital cockpit': 'Дигитално табло',
  'Driver-side airbag': 'Airbag за водача',
  'Electronic stability control': 'Електронна стабилизация (ESC)',
  'Engine Immobilizer': 'Имобилайзер',
  'Fog lights': 'Фарове за мъгла',
  'Front Collision Warning': 'Предупреждение за сблъсък',
  'Full-LED headlights': 'Изцяло LED фарове',
  'Heads-up display': 'Head-up дисплей',
  'Heated Seats': 'Подгряваеми седалки',
  'Heated steering wheel': 'Подгряваем волан',
  'Integrated music streaming': 'Музикален стрийминг',
  'LED Daytime Running Lights': 'LED дневни светлини',
  'Lane departure warning system': 'Предупреждение при напускане на лентата',
  'Leather seats': 'Кожени седалки',
  'Leather steering wheel': 'Кожен волан',
  'MP3 Player': 'MP3 плейър',
  'Navigation system': 'Навигация',
  'On-board computer': 'Бордови компютър',
  'Panoramic Roof': 'Панорамен покрив',
  'Park Distance Control': 'Парктроник',
  'Parking Assist Rear Sensors': 'Задни сензори за паркиране',
  'Passenger-side airbag': 'Airbag за пътника',
  'Power Door Locks': 'Централно заключване',
  'Power Mirrors': 'Електрически огледала',
  'Power Seats': 'Електрически седалки',
  'Power windows': 'Електрически стъкла',
  'PowerSteering': 'Серво управление',
  'Rain Sensing Wipers': 'Сензор за дъжд',
  'Rear Spoiler': 'Заден спойлер',
  'Remote Keyless Entry': 'Безключово отключване',
  'Roof rack': 'Релси за покрив',
  'Side airbag': 'Странични airbag-и',
  'Sliding door': 'Плъзгаща се врата',
  'Sound system': 'Аудио система',
  'Spare Tire': 'Резервна гума',
  'Split Bench Seat': 'Делима задна седалка',
  'Start-stop system': 'Start-stop система',
  'Steering Wheel Audio Controls': 'Управление на аудиото от волана',
  'Sun/Moonroof': 'Шибидах',
  'Television': 'Телевизия',
  'Tinted windows': 'Затъмнени стъкла',
  'Traction control': 'Тракшън контрол',
  'Traffic sign recognition': 'Разпознаване на пътни знаци',
  'Trailer hitch': 'Теглич',
  'Voice Control': 'Гласово управление',
  'Wireless Charging': 'Безжично зареждане',
};

export const translateEquipment = (item: string): string => EQUIPMENT_BG[item] ?? item;
